export default __webpack_public_path__ + "static/csec-7e979d043607e29a7886b9a9a9e843f6.mp4";